/* @flow weak */
import map from 'lodash/map';
import * as React from 'react';
import flow from 'lodash/flow';
import sortBy from 'lodash/sortBy';
import { filter } from 'fuzzaldrin';
import Link from 'components/Link';
import Input from 'components/Input';
import SettingsStore from 'stores/SettingsStore';
import Hovercard from 'components/Hovercard';
import HovercardBody from 'components/HovercardBody';

import './styles/LanguageHoverCard.scss';

type Props = {
  onRequestHide?: Function,
  onLanguagePicked: Function,
  eventContextName?: string,
  eventProperties?: any,
};

type State = {
  query: string,
};

class LanguageHoverCard extends React.Component<Props, State> {
  state: State = {
    query: '',
  };

  handleSearchChange = event => {
    this.setState({ query: event.target.value });
  };

  handleLanguageClick = (code: string) => {
    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }

    this.props.onLanguagePicked(code);
  };

  render() {
    const languages = {
      ...SettingsStore.getPrimaryLanguages(),
      ...SettingsStore.getLanguages().secondary,
    };

    const compute = flow(
      a => Object.entries(a),
      a => map(a, ([code, name]) => ({ code, name })),
      a => filter(a, this.state.query, { key: 'name' }),
      a => sortBy(a, 'name')
    );

    const items = compute(languages).map(language => (
      <Link
        {...this.props}
        key={language.code}
        className="LanguageHoverCard-language"
        eventKey="announcements.announcement_modal.universal_composer.translation_language_cell.click"
        eventProperties={{
          language_code: language.code,
          ...this.props.eventProperties,
        }}
        onClick={() => this.handleLanguageClick(language.code)}>
        {language.name}
      </Link>
    ));

    return (
      <Hovercard {...this.props} className="LanguageHoverCard">
        <HovercardBody className="LanguageHoverCard-body">
          <div className="LanguageHoverCard-search">
            <Input
              autofocus
              onChange={this.handleSearchChange}
              placeholder="Search for a language"
            />
          </div>
          {items.length >= 1 && <div className="LanguageHoverCard-items">{items}</div>}
          {items.length <= 0 && (
            <div className="LanguageHoverCard-noResult">
              No result found for “{this.state.query}”
            </div>
          )}
        </HovercardBody>
      </Hovercard>
    );
  }
}

export default LanguageHoverCard;
